<template>
  <a @click="$emit('click')" class="requestDescription">
    {{ text }}
  </a>
</template>

<script>
export default {
  name: 'RequestDescription',
  props: {
    status: {
      required: true,
      validator(status) {
        return ['waiting', 'approved', 'rejected', 'cancel'].includes(status)
      },
    },
    type: {
      required: true,
      validator(type) {
        return ['new', 'update', 'delete'].includes(type)
      },
    },
  },
  computed: {
    text() {
      if (this.type === 'new') {
        switch (this.status) {
          case 'waiting': {
            return '申請中です'
          }
          case 'rejected': {
            return '申請が却下されました'
          }
          default: {
            return ''
          }
        }
      } else if (this.type === 'delete') {
        switch (this.status) {
          case 'waiting': {
            return '削除申請中です'
          }
          case 'rejected': {
            return '削除申請が却下されました'
          }
          default: {
            return ''
          }
        }
      } else {
        switch (this.status) {
          case 'waiting': {
            return '申請中の変更があります'
          }
          case 'rejected': {
            return '却下された変更があります'
          }
          default: {
            return ''
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.requestDescription {
  text-decoration: underline;
}
</style>
